/**
 * Imperative bridge so non-React code (the Apollo error link) can push snackbars:
 * `SnackbarProvider` registers `setCustomSnack` here; callers use `notify(...)`.
 */

export type TranslationOptions = Record<string, unknown>;

export interface ISnackbarData {
  visibility: boolean;
  /** i18n key (or literal string) — rendered via `t(message, messageOpts)`. */
  message: string;
  messageOpts?: TranslationOptions;
  durationInMs?: number;
  isTimerIcon?: boolean;
  /** Correlation ID — when set, the snackbar shows a short support-ticket reference. */
  referenceId?: string;
}

type Notifier = (data: ISnackbarData) => void;

let notifier: Notifier | null = null;
// Buffers boot-time notifications until `SnackbarProvider` mounts. Capped against a runaway loop.
const queue: ISnackbarData[] = [];
const QUEUE_CAP = 16;

export const registerNotifier = (fn: Notifier | null): void => {
  notifier = fn;
  if (fn && queue.length) {
    const buffered = queue.splice(0);
    buffered.forEach(fn);
  }
};

/** Show a snackbar from anywhere. Buffers if `SnackbarProvider` hasn't mounted yet. */
export const notify = (data: ISnackbarData): void => {
  if (notifier) {
    notifier(data);
  } else if (queue.length < QUEUE_CAP) {
    queue.push(data);
  }
};
